import React, { FC } from "react";

const STATS_OVERVIEW_STYLE = {
    background: "white",
    padding: "10px",
    border: "1px solid #efefef",
};

const STATS_OVERVIEW_TABLE_STYLE = {
    width: "100%",
    paddingRight: "10px",
    paddingBottom: "10px",
    borderSpacing: "0px",
};

const STATS_OVERVIEW_TD_STYLE = {
    padding: "5px",
};

const STATS_OVERVIEW_HEADER_STYLE = {
    textAlign: "center" as const,
    marginBottom: "10px",
    marginTop: "10px",
};

interface OverviewStatsPropsInterface {
	interviews: number;
	insights: number;
	hypotheses: number;
	validHypotheses: number;
	invalidHypotheses: number;
}

const OverviewStats: FC<OverviewStatsPropsInterface> = (props) => {
	const {
		interviews,
		insights,
		hypotheses,
		validHypotheses,
		invalidHypotheses,
	} = props;

	return (
		<div style={STATS_OVERVIEW_STYLE}>
			<h3 style={STATS_OVERVIEW_HEADER_STYLE}>Overview</h3>
			<table
				className="iw-table iw-table-overview"
				style={STATS_OVERVIEW_TABLE_STYLE}
			>
				<tbody>
					<tr className="cs-tr-group">
						<td style={STATS_OVERVIEW_TD_STYLE}>Interviews</td>
						<td style={STATS_OVERVIEW_TD_STYLE}>{interviews}</td>
					</tr>

					<tr className="cs-tr-group">
						<td style={STATS_OVERVIEW_TD_STYLE}>Insights</td>
						<td style={STATS_OVERVIEW_TD_STYLE}>{insights}</td>
					</tr>

					<tr className="cs-tr-group">
						<td style={STATS_OVERVIEW_TD_STYLE}>Hypotheses</td>
						<td style={STATS_OVERVIEW_TD_STYLE}>{hypotheses}</td>
					</tr>

					<tr className="cs-tr-group">
						<td style={STATS_OVERVIEW_TD_STYLE}>Validated Hypotheses</td>
						<td style={STATS_OVERVIEW_TD_STYLE}>{validHypotheses}</td>
					</tr>

					<tr className="cs-tr-group">
						<td style={STATS_OVERVIEW_TD_STYLE}>Invalidated Hypotheses</td>
						<td style={STATS_OVERVIEW_TD_STYLE}>{invalidHypotheses}</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default OverviewStats;
